import { useTranslate } from '../../TranslationsContext'
import './Video.css'

export function Video() {
  const translate = useTranslate()
  const videoId = translate('Video.id')

  return videoId === 'Video.id' ? null : (
    <div className="Video">
      <iframe
        width="560"
        height="315"
        src={`https://www.youtube.com/embed/${videoId}?controls=0&color=white&iv_load_policy=3&modestbranding=1&rel=0`}
        title="Video manifesto"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  )
}
